import { Injectable } from '@angular/core';

import { UtilService } from "../../../shared/services/util.service";
import { PessoaJuridicaApiService } from "./pessoa-juridica-api.service";

@Injectable()
export class PessoaJuridicaService {

  constructor(
    private _pessoaJuridicaApiService: PessoaJuridicaApiService,
    private _utilService: UtilService
  ) { }

  onSubmit(object, onDone) {
    if (object.cnpj) {
      object.cnpj = this._utilService.removeSpecialCharacter(object.cnpj);
    }

    if (object.telefone) {
      object.telefone = this._utilService.removeSpecialCharacter(object.telefone);
    }

    if (object.id) {
      this._pessoaJuridicaApiService.onPut(object, onDone);
    } else {
      this._pessoaJuridicaApiService.onPost(object, onDone);
    }
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/pessoa-juridica/shared/pessoa-juridica.service.ts
 **/